import { IBaseRequestGetPaged, IMultiLanguageContent } from "./../../commons/interfaces";
import Helpers from "../../commons/helpers";
import IdentityClient from "./IdentityClient";

import { Constants } from "../../constants/constants";
import { IPagedList, IResource } from "../../commons/interfaces";
import { AccessMode, ResourceType } from "../../constants/enums";

export interface IRequestGetPagedResource extends IBaseRequestGetPaged {
    clientId?: string;
    resourceType: number;
    organizationId?: string;
    parentResource?: string;
    serviceCode: string;
    statuses?: number[];
}

export interface IRequestGetAllResource {
    resourceType: ResourceType[];
    serviceCode: string;
    organizationId?: string;
    parentResource?: string;
    accessMode?: AccessMode;
    statuses?: number[];
}

export interface ExtraInformations {
    targetId: number;
    key: string;
    type: string;
    noCollapse: boolean;
    screen: string;
    isAuth: boolean;
}

export interface ResourceDetailRequest {
    id?: string;
    editMode: number;
    controller: string;
    action: string;
    method: string;
}

export interface ResourceModuleRequest {
    resourceCode: string;
    editMode: number;
    id?: string;
}

export interface IRequestUpdateResource {
    serviceCode: string;
    resourceType: number;
    adminFeature: number;
    resourceURI: string;
    clientId: string;
    resourceName: IMultiLanguageContent;
    extraInformations?: ExtraInformations;
    description: IMultiLanguageContent;
    accessMode: number;
    organizationId: string;
    id: string;
    updateTime: string | number;
    resourceModuleRequests: ResourceModuleRequest[];
    resourceDetailRequests?: ResourceDetailRequest[];
}
export interface ResourcePermissions {
    id: string;
    roleCode: string;
    resourceCode: string;
    permission: number;
}

export type IResourceTemplate = Omit<IResource, "moduleResourceResponses"> & {
    resourcePermissions: ResourcePermissions[];
};

export type IRequestCreateResource = Omit<IRequestUpdateResource, "id">;

interface IGetTemplateRequest {
    type: number;
    serviceCode?: string;
}

const ResourceService = {
    async getAll(data: IRequestGetAllResource): Promise<IResource[]> {
        const query = Helpers.handleFormatParams(data);
        const result = await IdentityClient().get(`${Constants.ApiPath.RESOURCE.GET_ALL}?${query}`);
        return result.data.result;
    },

    async getTemplate(data: IGetTemplateRequest): Promise<IResourceTemplate[]> {
        const query = Helpers.handleFormatParams(data);
        const result = await IdentityClient().get(`${Constants.ApiPath.RESOURCE.GET_TEMPLATE}?${query}`);
        return result.data.result;
    },

    async getPaged(data: IRequestGetPagedResource): Promise<IPagedList<IResource>> {
        const result = await IdentityClient().get(`${Constants.ApiPath.RESOURCE.GET_PAGED}?${Helpers.handleFormatParams(data)}`);
        return result.data.result;
    },

    async getDefaultResourceDetail() {
        const result = await IdentityClient().get(`${Constants.ApiPath.RESOURCE.GET_TEMPLATE}`);
        return result.data.result;
    },

    async getDetail(id: string): Promise<IResource> {
        const result = await IdentityClient().get(Constants.ApiPath.RESOURCE.GET_DETAIL + `/${id}`);
        return result.data.result;
    },

    async delete(data: string[]) {
        const result = await IdentityClient().delete(Constants.ApiPath.RESOURCE.DELETE, { data });
        return result.data;
    },

    async create(data: any) {
        const result = await IdentityClient().post(Constants.ApiPath.RESOURCE.CREATE, data);
        return result.data;
    },

    async update(data: any) {
        const result = await IdentityClient().post(Constants.ApiPath.RESOURCE.UPDATE, data);
        return result.data;
    },

    // async initData (serviceCode: string) {
    //     const result = await IdentityClient().post(
    //        Constants.ApiPath.RESOURCE.INIT_DATA,
    //         data: { "serviceCode": serviceCode }
    //     );
    //     return result.data;
    // }
};

export default ResourceService;
